export const AD_SLOTS = {
  BASICS: "6375805619",
  TOP: "3530134511",
  TOP_FOOTER: "3968672340",
  ABOUT: "1058123654",
  BLOG: "4353555195",
  HOWTO_TOP: "3428301970",
  HOWTO_MID: "7354302213",
  HOWTO_BOTTOM: "6041220548",
  AFFORDABLE_TOP: "8072240099",
  AFFORDABLE_FAQ: "1183683525",
  BOTTOM_3D: "6580880478",
};
